import { render, staticRenderFns } from "./JxxChart.vue?vue&type=template&id=4bf3c1a4&scoped=true"
import script from "./JxxChart.vue?vue&type=script&lang=js"
export * from "./JxxChart.vue?vue&type=script&lang=js"
import style0 from "./JxxChart.vue?vue&type=style&index=0&id=4bf3c1a4&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf3c1a4",
  null
  
)

export default component.exports